"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibleColumnType = exports.ViewTypeName = exports.SortDirection = exports.ViewFieldSupport = void 0;
/**
 * The supported behavoirs that a view field may have
 */
var ViewFieldSupport;
(function (ViewFieldSupport) {
    ViewFieldSupport["visibility"] = "visibility";
    ViewFieldSupport["sort"] = "sort";
    ViewFieldSupport["groupBy"] = "groupBy";
})(ViewFieldSupport || (exports.ViewFieldSupport = ViewFieldSupport = {}));
/**
 * The direction of sort
 */
var SortDirection;
(function (SortDirection) {
    SortDirection["desc"] = "desc";
    SortDirection["asc"] = "asc";
})(SortDirection || (exports.SortDirection = SortDirection = {}));
/**
 * The different view type names that view fields can be configured against
 */
var ViewTypeName;
(function (ViewTypeName) {
    ViewTypeName["table"] = "table";
    ViewTypeName["gallery"] = "gallery";
    ViewTypeName["kanban"] = "kanban";
})(ViewTypeName || (exports.ViewTypeName = ViewTypeName = {}));
/**
 * The type of a visible column
 */
var VisibleColumnType;
(function (VisibleColumnType) {
    VisibleColumnType["customFieldValue"] = "CustomFieldValue";
    VisibleColumnType["unassignedCustomFieldValue"] = "UnassignedCustomFieldValue";
})(VisibleColumnType || (exports.VisibleColumnType = VisibleColumnType = {}));
//# sourceMappingURL=configurableView.js.map